<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container px-0">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Search Results</h5>
                  </div>
                  <small class="text-truncate text-muted">Type your search again</small>
                </div>
              </div>
            </div>

          </div> <!-- .row end -->

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container px-0">

          <!-- activity -->
          <div class="row py-4">
            <div class="col-md-8 offset-md-2">
              <div class="pt-3 pb-4">
                <div class="input-group">
                  <input type="text" class="form-control" value="Admin Dashboard">
                  <div class="input-group-append">
                    <button type="button" class="btn btn-primary"><i class="fa fa-search me-1"></i> Search</button>
                  </div>
                </div>
                <div class="mt-4 text-center">
                  <h6>Search Results For "Admin Dashboard"</h6>
                </div>
              </div>
            </div>
          </div>
          <!-- end row -->

          <div class="row">
            <div class="col-lg-12">
              <div class="search-result-box card-box">
                <ul class="nav nav-tabs page-header-tabs">
                  <li class="nav-item"><a href="javascript:void(0)" (click)="onMenuTab('1')"
                      [ngClass]="{'active': allTab}" class="nav-link active">All results
                      <span class="badge bg-success ms-1">325</span></a></li>
                  <li class="nav-item"><a href="javascript:void(0)" (click)="onMenuTab('2')"
                      [ngClass]="{'active': userTab}" class="nav-link">Users <span
                        class="badge bg-danger ms-1">89</span></a></li>
                </ul>
                <div class="tab-content mt-4">
                  <!-- Search: all -->
                  <div class="tab-pane active" id="search-home" [ngClass]="{'show active': allTab}">
                    <div class="search-item mb-4 pb-2 border-bottom">
                      <h6 class="mb-1"><a href="javascript:void(0)">Oculux React - Admin Dashboard Template</a></h6>
                      <div class="small text-primary mb-2">
                        https://themeforest.net/item/oculux-react-admin-dashboard-template/28784100</div>
                      <p class="text-muted">It is a long established fact that a reader will be distracted by the
                        readable
                        content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a
                        more-or-less normal distribution of letters, as opposed to using 'Content here, content here',
                        making it look like readable English.</p>
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item"><span class="badge bg-info">React</span></li>
                        <li class="list-inline-item"><small>Dec 27 2020</small></li>
                      </ul>
                    </div>
                    <div class="search-item mb-4 pb-2 border-bottom">
                      <h6 class="mb-1"><a href="javascript:void(0)">Qubis - Multipurpose Bootstrap Admin Template</a>
                      </h6>
                      <div class="small text-primary mb-2">
                        https://themeforest.net/item/qubes-bootstrap-admin-template/28614307</div>
                      <p class="text-muted">Dolor posuere proin blandit accumsan senectus netus nullam curae, ornare
                        laoreet adipiscing luctus mauris adipiscing pretium eget fermentum, tristique lobortis est ut
                        metus lobortis tortor tincidunt himenaeos habitant quis dictumst proin odio sagittis purus mi,
                        nec
                        taciti vestibulum quis in sit varius lorem sit metus mi.</p>
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item"><span class="badge bg-warning">HTML</span></li>
                      </ul>
                    </div>
                    <div class="search-item mb-4 pb-2 border-bottom">
                      <div class="media">
                        <img class="d-flex me-3 avatar rounded" src="assets/images/xs/avatar10.jpg" alt="avatar">
                        <div class="media-body">
                          <h6 class="media-heading mt-0">
                            <a href="javascript:void(0)">Chadengle</a>
                          </h6>
                          <p class="small"><b>Email:</b> <span><a href="javascript:void(0)"
                                class="text-muted">mediaheader@mail.com</a></span></p>
                          <p class="mb-0 small"><b>Bio:</b>
                            <br><span class="text-muted">Cras sit amet nibh libero, in gravida nulla. Nulla vel metus
                              scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus
                              viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue
                              felis in faucibus.</span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="search-item mb-4 pb-2 border-bottom">
                      <h6 class="mb-1"><a href="javascript:void(0)">Mooli Pro - Angular, Laravel, & HTML Admin Dashboard
                          Template</a></h6>
                      <div class="small text-primary mb-2">
                        https://themeforest.net/item/mooli-responsive-admin-dashboard-template/26561151</div>
                      <p class="text-muted">There are many variations of passages of Lorem Ipsum available, but the
                        majority have suffered alteration in some form, by injected humour, or randomised words which
                        don't look even slightly believable.</p>
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item"><span class="badge bg-danger">Angular</span></li>
                        <li class="list-inline-item"><small>Aug 9 2020</small></li>
                      </ul>
                    </div>
                    <div class="search-item mb-4 pb-2 border-bottom">
                      <h6 class="mb-1"><a href="javascript:void(0)">Epic React - HR Management Admin Template</a></h6>
                      <div class="small text-primary mb-2">
                        https://themeforest.net/item/epic-react-hr-management-admin-template/27418832</div>
                      <div>
                        <img class="avatar rounded sm" src="assets/images/xs/avatar1.jpg" data-bs-toggle="tooltip"
                          title="avatar" alt="image">
                        <img class="avatar rounded sm" src="assets/images/xs/avatar2.jpg" data-bs-toggle="tooltip"
                          title="avatar" alt="image">
                        <img class="avatar rounded sm" src="assets/images/xs/avatar3.jpg" data-bs-toggle="tooltip"
                          title="avatar" alt="image">
                        <img class="avatar rounded sm" src="assets/images/xs/avatar4.jpg" data-bs-toggle="tooltip"
                          title="avatar" alt="image">
                      </div>
                    </div>
                    <div class="search-item mb-4 pb-2 border-bottom">
                      <h6 class="mb-1"><a href="javascript:void(0)">Oculux - Bootstrap 4.5.0 Admin Dashboard Template &
                          UI KIT</a></h6>
                      <div class="small text-primary mb-2">
                        https://themeforest.net/item/oculux-bootstrap-4x-admin-dashboard-clean-modern-ui-kit/23091507
                      </div>
                      <p class="mb-0 text-muted">Contrary to popular belief, Lorem Ipsum is not simply random text. It
                        has
                        roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
                    </div>
                    <div class="search-item mb-4 pb-2 border-bottom">
                      <h6 class="mb-1"><a href="javascript:void(0)">puffintheme - Portfolio</a></h6>
                      <div class="small text-primary mb-2">https://themeforest.net/user/puffintheme/portfolio</div>
                      <p class="mb-0 text-muted">It was popularised in the 1960s with the release of Letraset sheets
                        containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus
                        PageMaker including versions of Lorem Ipsum.</p>
                    </div>
                    <ul class="pagination pagination-custom mt-4">
                      <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Previous"><span
                            aria-hidden="true">«</span> <span class="sr-only">Previous</span></a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0)">1</a></li>
                      <li class="page-item active"><a class="page-link" href="javascript:void(0)">2</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0)">3</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0)">4</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0)">5</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Next"><span
                            aria-hidden="true">»</span> <span class="sr-only">Next</span></a></li>
                    </ul>
                  </div>

                  <!-- Search: Users -->
                  <div class="tab-pane" id="search-users" [ngClass]="{'show active': userTab}">
                    <div class="search-item mb-4 pb-2 border-bottom">
                      <div class="media">
                        <div class="avatar me-3">
                          <img class="avatar rounded" src="assets/images/xs/avatar5.jpg" alt="avatar">
                        </div>
                        <div class="media-body overflow-hidden">
                          <div class="d-flex align-items-center justify-content-between mb-1">
                            <h6 class="text-truncate mb-0 me-auto">Jason Porter</h6>
                          </div>
                          <div>
                            <p class="mb-0"><b>Email:</b> <span><a href="javascript:void(0)"
                                  class="text-muted">mediaheader@mail.com</a></span></p>
                            <p class="mb-0">
                              <b>Bio:</b>
                              <span class="text-muted">All the Lorem Ipsum generators on the Internet tend to repeat
                                predefined chunks as necessary, making this the first true generator on the
                                Internet.</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="search-item mb-4 pb-2 border-bottom">
                      <div class="media">
                        <div class="avatar me-3">
                          <img class="avatar rounded" src="assets/images/xs/avatar1.jpg" alt="avatar">
                        </div>
                        <div class="media-body overflow-hidden">
                          <div class="d-flex align-items-center justify-content-between mb-1">
                            <h6 class="text-truncate mb-0 me-auto">Lisa Garett </h6>
                          </div>
                          <div>
                            <p class="mb-0"><b>Email:</b> <span><a href="javascript:void(0)"
                                  class="text-muted">LisaGarett@mail.com</a></span></p>
                            <p class="mb-0">
                              <b>Bio:</b>
                              <span class="text-muted">it look like readable English. Many desktop publishing packages
                                and
                                web page editors now use Lorem Ipsum as their default model text, and a search for
                                'lorem
                                ipsum' will uncover</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="search-item mb-4 pb-2 border-bottom">
                      <div class="media">
                        <div class="avatar me-3">
                          <img class="avatar rounded" src="assets/images/xs/avatar2.jpg" alt="avatar">
                        </div>
                        <div class="media-body overflow-hidden">
                          <div class="d-flex align-items-center justify-content-between mb-1">
                            <h6 class="text-truncate mb-0 me-auto">Marshall Nichols </h6>
                          </div>
                          <div>
                            <p class="mb-0"><b>Email:</b> <span><a href="javascript:void(0)"
                                  class="text-muted">MarshallNichols
                                  @mail.com</a></span></p>
                            <p class="mb-0">
                              <b>Bio:</b>
                              <span class="text-muted">There are many variations of passages of Lorem Ipsum available,
                                but
                                the majority have suffered alteration in some form, by injected humour, or randomised
                                words</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="search-item mb-4 pb-2 border-bottom">
                      <div class="media">
                        <div class="avatar me-3">
                          <img class="avatar rounded" src="assets/images/xs/avatar4.jpg" alt="avatar">
                        </div>
                        <div class="media-body overflow-hidden">
                          <div class="d-flex align-items-center justify-content-between mb-1">
                            <h6 class="text-truncate mb-0 me-auto">Debra Stewart</h6>
                          </div>
                          <div>
                            <p class="mb-0"><b>Email:</b> <span><a href="javascript:void(0)"
                                  class="text-muted">DebraStewart@mail.com</a></span></p>
                            <p class="mb-0">
                              <b>Bio:</b>
                              <span class="text-muted">it look like readable English. Many desktop publishing packages
                                and
                                web page editors now use Lorem Ipsum as their default model text, and a search for
                                'lorem
                                ipsum' will uncover</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="search-item mb-4 pb-2 border-bottom">
                      <div class="media">
                        <div class="avatar me-3">
                          <img class="avatar rounded" src="assets/images/xs/avatar6.jpg" alt="avatar">
                        </div>
                        <div class="media-body overflow-hidden">
                          <div class="d-flex align-items-center justify-content-between mb-1">
                            <h6 class="text-truncate mb-0 me-auto">Louis Henry</h6>
                          </div>
                          <div>
                            <p class="mb-0"><b>Email:</b> <span><a href="javascript:void(0)"
                                  class="text-muted">LouisHenry
                                  @mail.com</a></span></p>
                            <p class="mb-0">
                              <b>Bio:</b>
                              <span class="text-muted">There are many variations of passages of Lorem Ipsum available,
                                but
                                the majority have suffered alteration in some form, by injected humour, or randomised
                                words</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ul class="pagination pagination-custom mt-4">
                      <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Previous"><span
                            aria-hidden="true">«</span> <span class="sr-only">Previous</span></a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0)">1</a></li>
                      <li class="page-item active"><a class="page-link" href="javascript:void(0)">2</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0)">3</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0)">4</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0)">5</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Next"><span
                            aria-hidden="true">»</span> <span class="sr-only">Next</span></a></li>
                    </ul>
                  </div>

                </div>
              </div>
            </div>
          </div> <!-- .row end -->

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
